import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-thank-you',
    imports: [CommonModule],
    template: `
    <div class="view-wrapper">
      <h1>Thank you</h1>
      <h4>Your form has been submitted successfully</h4>
    </div>
  `,
    styles: ['']
})
export class ThankYouComponent {}
